import React from "react";
import { ConfirmModal } from "../../../../boxes/ConfirmModal/ConfirmModal";

const RefundConfirmationModal = ({ onClose, onCancel, onConfirm }) => {
  return (
    <ConfirmModal
      isOpen
      onClose={onClose}
      onCancel={onCancel}
      onConfirm={onConfirm}
    >
      <p>
        This invoice contains items that were sent to the wallet and have been
        partially or fully redeemed. You can still refund the invoice but to
        delete any remaining credits, you must manually remove them from the
        wallet.
      </p>
    </ConfirmModal>
  );
};

export default RefundConfirmationModal;
